export enum RendererApiRoute {
  DYNAMIC_CONTENT_ENTRIES = "/api/dynamic-content/entries",
  WHATSAPP_COLLECTION_ENTRIES = "/api/whatsapp/collection-entries",
  POPUPS_TRACK = "/api/popups/track",
  SUBSCRIPTION_COUPONS_VALIDATE = "/api/subscription-coupons/validate",
}
